import { View } from 'react-native';
import { Props, Breeder, Animal, MediaAsset } from 'shared/@types';
import { useTranslation } from 'react-i18next';
import { H2 } from 'shared/components/title';
import { BreederPetCard } from 'shared/components/breeder-pet-card';
import { PageBuilder } from 'shared/library/page-builder';
import { apiRoute } from 'shared/library/api-route';
import { Text } from 'shared/components/text';

interface BreederProfilePetsScreenProps extends Props {
  breeder: Breeder;
  mediaAssets: MediaAsset[];
}

const BreederProfilePetsScreen = ({ breeder }: BreederProfilePetsScreenProps) => {
  const { t } = useTranslation('screens');
  const breederPets = breeder.breeder_pets ?? [];

  return (
    <View className={'gap-4 md:gap-6'}>
      <H2
        title={
          breeder.animal === Animal.Dog
            ? t('breeders.show_breeder.our_dogs')
            : t('breeders.show_breeder.our_cats')
        }
        marginTop={false}
        marginBottom={false}
      />

      {breederPets.length > 0 ? (
        <View className={'gap-6'}>
          {breederPets.map((pet) => (
            <BreederPetCard key={pet.uuid} pet={pet} />
          ))}
        </View>
      ) : (
        <Text className={'text-brand-brown-dark/70 max-w-prose'}>
          {breeder.animal === Animal.Dog
            ? t('breeders.show_breeder.no_dogs_added')
            : t('breeders.show_breeder.no_cats_added')}
        </Text>
      )}
    </View>
  );
};

BreederProfilePetsScreen.pageBuilder = new PageBuilder<
  BreederProfilePetsScreenProps,
  { breeder: string }
>().request(({ req, params }) =>
  req<{ breeder: Breeder; media_assets: MediaAsset[] }>(
    apiRoute('breeders.show', { breeder: params.breeder }),
    {
      compact: true,
      include: 'breeder_pets,media_assets',
    },
  ).then((data) => ({
    breeder: data.breeder,
    mediaAssets: data.media_assets,
  })),
);

export { BreederProfilePetsScreen };
export type { BreederProfilePetsScreenProps };
